<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ insightVector.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : insightVector.length }} of {{ insightVector.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <!-- <datepicker class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="날짜" :language="$vs.rtl ? langHe : langEn" v-model="selectDate" :highlighted="highlightedFn"/> -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />

        <!-- <div v-if="activeUserLevel >= 3" class="p-3 rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-35">
          <vue-excel-xlsx :data="excelData" :columns="excelColumns" :filename="excelFileName" :sheetname="'sheet'">
            <vs-button  icon-pack="feather" icon="icon-download" type="flat" style="margin-left:8px; margin-right:8px; margin-bottom:5px;" color="dark" size="small">Export</vs-button>
          </vue-excel-xlsx>
        </div> -->
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="projectsInfo"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage"/>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import { ko, he } from "vuejs-datepicker/src/locale"
// Store Module
// import moduleInsight from '@/store/insight/moduleInsight.js'

// Cell Renderer
import InsightProjectLink from "./cell-renderer/InsightProjectLink.vue"
import InsightStatus from "./cell-renderer/InsightStatus.vue"
import InsightTotalAttend from "./cell-renderer/InsightTotalAttend.vue"
import InsightActions from "./cell-renderer/InsightActions.vue"
// import InsightProjectScore from "./cell-renderer/InsightProjectScore.vue"
// import InsightProjectResult from "./cell-renderer/InsightProjectResult.vue"


export default {
  components: {
    AgGridVue,
    vSelect,
    InsightProjectLink,
    InsightStatus,
    InsightTotalAttend,
    InsightActions,
    // InsightProjectScore,
    // InsightProjectResult,
    Datepicker
  },
  data() {
    return {
      excelFileName:'',
      excelColumns:[],
      excelData:[],
      days:[],
      selectDate: new Date(),
      highlightedFn: {},
      langHe: he,
      langEn: ko,
      searchQuery: "",
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: [
        {
          headerName: '프로젝트',
          field: 'name',
          width: 101,
          cellRendererFramework: 'InsightProjectLink'
        },
        {
          headerName: '맴버',
          field: 'member',
          width: 101,

        },
        {
          headerName: '평가',
          field: 'score',
          width: 101,
          // cellRendererFramework: 'InsightProjectScore'
        },
        {
          headerName: '결과물',
          field: 'file_name',
          width: 101,
          // cellRendererFramework: 'InsightProjectResult'
        },
        {
          headerName: '완료업무',
          field: 'task_count',
          width: 101,
        },
        {
          headerName: '블로그',
          field: 'blog_count',
          width: 101,
        },

      ],
      // Cell Renderer Components
      components: {
        InsightProjectLink,
        // InsightProjectScore,
        // InsightProjectResult,

      },
    }
  },
  computed: {
    insightVector(){
      return this.$store.state.insight.insightVector
    },
    projectsInfo(){
      return this.$store.state.insight.projectsInfo
    },
    activeUserLevel() {
      return this.$store.state.space.ActiveDashBoardLevel
    },
    activeWorkspace() {
      return this.$store.state.space.ActiveSpaceInfo
    },
    workspaceMembers() {
      return this.$store.state.space.workspaceMembers
    },
    attends(){
      return this.$store.state.insight.attends
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
  },
  created() {
    this.$store.dispatch("insight/getProjectInsight", this.activeWorkspace.id)
    // this.excelColumns = [{label:'프로젝트', field:'name'}, {label:'멤버', field:'attend_count'}, {label:'업무', field:'late_count'}, {label:'작성글', field:'miss_count'}, {label:'결과물', field:'miss_count'}]
    // this.excelFileName = '[필드유] '+this.activeWorkspace.title +'_출석부_'+ this.$moment(new Date).format('MM-DD')

    // if(!this.attends){
    //   this.$store.dispatch("insight/getAttend", this.activeWorkspace.id).then(()=>{
    //     for(var i in this.attends){
    //       var attend = this.attends[i].attend
    //       // day = this.$moment(attend.day_time).format('MM-DD')
    //       this.columnDefs.push({headerName: this.$moment(attend.day_time).format('MM-DD') , field: 'attend'+i, width: 101, cellRendererFramework: 'InsightStatus'})
    //       this.excelColumns.push({label:this.$moment(attend.day_time).format('MM-DD'), field:'attend'+i})
    //       for (var j in this.insightVector){
    //         var user = this.insightVector[j]
    //         var fildName = 'attend'+i
    //         if(this.attends[i].miss.find((miss) => miss.user_id == user.user_id)){
    //           this.$store.commit("insight/UPDATE_ATTEND_VECTOR", {index:j, fildName:fildName, attendVal:3})
    //         }
    //         else if (this.attends[i].late.find((late) => late.user_id == user.user_id)){
    //           this.$store.commit("insight/UPDATE_ATTEND_VECTOR", {index:j, fildName:fildName, attendVal:2})
    //         } else{
    //           this.$store.commit("insight/UPDATE_ATTEND_VECTOR", {index:j, fildName:fildName, attendVal:1})
    //         }
    //       }
    //     }
    //   })
    // } else{
    //   for(var i in this.attends){
    //     var attend = this.attends[i].attend
    //     this.columnDefs.push({headerName: this.$moment(attend.day_time).format('MM-DD') , field: 'attend'+i, width: 101, cellRendererFramework: 'InsightStatus'})
    //     this.excelColumns.push({label:this.$moment(attend.day_time).format('MM-DD'), field:'attend'+i})
    //   }
    // }
    // this.excelData = this.insightVector
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
